import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import UserHeader from "@/components/user/UserHeader";
import Footer from "@/components/layout/Footer";

const monitoramento = [
  { mes: 'Abril', geradas: '135,32 KgCO2e', evitadas: '55,40 KgCO2e', txReducao: '29.05%', beneficio: 'R$ 0,00' },
  { mes: 'Março', geradas: '162,57 KgCO2e', evitadas: '28,15 KgCO2e', txReducao: '14.76%', beneficio: 'R$ 0,00' },
  { mes: 'Fevereiro', geradas: '185,18 KgCO2e', evitadas: '5,54 KgCO2e', txReducao: '2.90%', beneficio: 'R$ 30,00' },
  { mes: 'Janeiro', geradas: '190,72 KgCO2e', evitadas: 'NC', txReducao: '0.00%', beneficio: 'N/C' },
];

export default function MeuProjetoDetalhe() {
  const navigate = useNavigate();
  const [showCertModal, setShowCertModal] = useState(false);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <UserHeader />
      <div className="bg-white px-6 py-4 border-b border-gray-200">
        <div className="container mx-auto flex justify-between items-center">
          <h1 className="text-2xl font-bold text-gray-800">Detalhes do Projeto - Moeda Social Carbono</h1>
          <Button className="bg-[#0e7cb4] hover:bg-[#0a5c87] text-white" onClick={() => navigate('/my-projects')}>Voltar</Button>
        </div>
      </div>
      <div className="flex-grow p-6 bg-gray-50">
        <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Dados do usuário e projeto */}
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <h2 className="text-lg font-semibold mb-4 text-gray-800 border-b pb-2">Informações do Usuário</h2>
            <div className="mb-2"><b>ID:</b> 1</div>
            <div className="mb-2"><b>Projeto:</b> Cacuia Colônia Z10</div>
            <div className="mb-2"><b>Nome:</b> Alberto Lopes</div>
            <div className="mb-2"><b>Emissões em KgCO2e:</b> Geradas: 673,79</div>
            <div className="mb-2"><b>Total de emissões evitadas:</b> 89,08</div>
            <div className="mb-2"><b>Tx Redução:</b> 13.22%</div>
            <div className="mb-2"><b>Benefícios:</b> R$ 30,00</div>
            <h3 className="text-md font-semibold mt-6 mb-2 text-gray-800">Dados pessoais</h3>
            <div className="mb-1">E-mail: lilica467sabino@gmail.com</div>
            <div className="mb-1">Rua: Rua Alexandre Rosa</div>
            <div className="mb-1">Número: 13</div>
            <div className="mb-1">Complemento: Fundos</div>
            <div className="mb-1">Bairro: Cacuia</div>
            <div className="mb-1">Cidade: Rio de Janeiro</div>
            <div className="mb-1">Estado: Rio de Janeiro</div>
            <div className="mb-1">Telefone: (21) 97844-2102</div>
            <div className="mb-1">Nº Habitantes: 2</div>
          </div>
          {/* Tabela de monitoramento */}
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <h2 className="text-lg font-semibold mb-4 text-gray-800 border-b pb-2">Monitoramento Mensal</h2>
            <table className="min-w-full text-sm text-left">
              <thead>
                <tr className="border-b">
                  <th className="py-2 px-3">Projeto</th>
                  <th className="py-2 px-3">Nome</th>
                  <th className="py-2 px-3">Mês</th>
                  <th className="py-2 px-3">Emissões Geradas</th>
                  <th className="py-2 px-3">Emissões Evitadas</th>
                  <th className="py-2 px-3">Tx Redução</th>
                  <th className="py-2 px-3">Benefício</th>
                </tr>
              </thead>
              <tbody>
                {monitoramento.map((item, idx) => (
                  <tr key={idx} className="border-b">
                    <td className="py-2 px-3">Cacuia Colônia Z10</td>
                    <td className="py-2 px-3">Alberto Lopes</td>
                    <td className="py-2 px-3">{item.mes}</td>
                    <td className="py-2 px-3">{item.geradas}</td>
                    <td className="py-2 px-3">{item.evitadas}</td>
                    <td className="py-2 px-3">{item.txReducao}</td>
                    <td className="py-2 px-3">{item.beneficio}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* Seção Meus Certificados */}
          <div className="bg-white p-6 rounded-lg shadow-sm md:col-span-2 mt-8">
            <h2 className="text-lg font-semibold mb-4 text-gray-800 border-b pb-2">Meus Certificados</h2>
            <table className="min-w-full text-sm text-left">
              <thead>
                <tr className="border-b">
                  <th className="py-2 px-3">Nº</th>
                  <th className="py-2 px-3">Data de Emissão</th>
                  <th className="py-2 px-3">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b">
                  <td className="py-2 px-3">001</td>
                  <td className="py-2 px-3">31/03/2025</td>
                  <td className="py-2 px-3">
                    <Button variant="outline" size="sm" onClick={() => setShowCertModal(true)}>Visualizar</Button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* Seção Meus Tokens */}
          <div className="bg-white p-6 rounded-lg shadow-sm md:col-span-2 mt-8">
            <h2 className="text-lg font-semibold mb-4 text-gray-800 border-b pb-2">Meus Tokens</h2>
            <div className="mb-4">
              <p className="text-sm text-gray-600">1 MSC = 1 kg de CO₂ evitado</p>
            </div>
            <table className="min-w-full text-sm text-left">
              <thead>
                <tr className="border-b">
                  <th className="py-2 px-3">Nº</th>
                  <th className="py-2 px-3">Data</th>
                  <th className="py-2 px-3">Emissões Evitadas (kgCO₂)</th>
                  <th className="py-2 px-3">Tokens MSC</th>
                  <th className="py-2 px-3">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b">
                  <td className="py-2 px-3">001</td>
                  <td className="py-2 px-3">31/03/2025</td>
                  <td className="py-2 px-3">89,08</td>
                  <td className="py-2 px-3">89,08 MSC</td>
                  <td className="py-2 px-3">
                    <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">Ativo</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Footer />
      {/* Modal de visualização do certificado */}
      {showCertModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
          <div className="bg-white rounded-lg shadow-lg p-6 max-w-lg w-full relative flex flex-col items-center">
            <button
              className="absolute top-2 right-2 bg-gray-200 rounded-full p-1 hover:bg-gray-300"
              onClick={() => setShowCertModal(false)}
              aria-label="Fechar"
            >
              <span className="text-xl">&times;</span>
            </button>
            <img
              src="/certificates/certificado.jpg"
              alt="Certificado"
              className="w-full max-h-[60vh] object-contain mb-4 border"
            />
            <a
              href="/certificates/certificado.pdf"
              download
              className="bg-[#0e7cb4] hover:bg-[#0a5c87] text-white px-4 py-2 rounded font-medium mt-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              Baixar PDF
            </a>
          </div>
        </div>
      )}
    </div>
  );
} 